module.exports = __webpack_public_path__ + "static/media/building-view-team.a7f9af00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/building-view-team.jpg
// module id = 376
// module chunks = 0